import React, { useState } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import NewspaperIcon from "../../../icons/NewspaperIcon";
import DownloadSimpleIcon from "../../../icons/DownloadSimpleIcon";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../../../shadcn/components/ui/dialog";
import ContactAuthorizedOfficerCard from "../../../shadcn/components/custom/ContactAuthorizedOfficerCard";
import { useSelector } from "react-redux";
interface PDDownloadDocumentsProps {
  propertyData: any;
  setAuthModelOpen?: any;
  setAcknowledgementOpen?: any;
  setAcknowledgementDetails?: any;
}

export default function PDDownloadDocuments({
  propertyData,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
}: PDDownloadDocumentsProps) {
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [open, setOpen] = useState(false);
  const onClickHandler = () => {
    if (userToken) {
      return setOpen(true);
    }
    setAuthModelOpen(true);
  };
  return (
    <>
      {propertyData?.documents?.length > 0 && (
        <div className="mt-14 lg:mt-5 pt-8 pb-[47px] bg-brand-bgLightGrey px-5 clip-path-bottomRightPostProperty">
          <h4 className="text-xl font-openSans text-brand-textBlack">
            Property Documents
          </h4>

          <Button
            onClick={onClickHandler}
            className="bg-brand-lightOrange hover:bg-brand-lightOrange hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out mt-[26px] py-6 rounded-none"
          >
            <div className="flex items-center">
              <NewspaperIcon />
              <div className="text-brand-textBlack text-sm pl-2 pr-4 font-openSans">
                Download copy of publication
              </div>
              <div className="bg-black p-[6px] rounded-full">
                <DownloadSimpleIcon />
              </div>
            </div>
          </Button>

          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="max-w-[400px] rounded-lg">
              <DialogTitle className="hidden"> </DialogTitle>
              <DialogDescription className="hidden"></DialogDescription>
              <ContactAuthorizedOfficerCard
                formTitle={"Enter details"}
                propertyData={propertyData}
                setAcknowledgementOpen={setAcknowledgementOpen}
                setAcknowledgementDetails={setAcknowledgementDetails}
                setOpen={setOpen}
                cardType="downLoadProperties"
              />
            </DialogContent>
          </Dialog>
        </div>
      )}
    </>
  );
}
